import { render } from "./RockWeekModal.vue?vue&type=template&id=aa5059f4&scoped=true&ts=true"
import script from "./RockWeekModal.vue?vue&type=script&lang=ts"
export * from "./RockWeekModal.vue?vue&type=script&lang=ts"

import "./RockWeekModal.vue?vue&type=style&index=0&id=aa5059f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5059f4"]])

export default __exports__